import Rete from 'rete';
import trackNodeHistory from '../utils/history/trackNodeHistory';

import Frame from './Frame';

class FrameComponent extends Rete.Component {
  constructor(emitter) {
    super('Frame');
    this.render = 'vue';
    this.data.component = Frame;
    this.data.props = {};
    this.emitter = emitter;
  }
  builder = (node) => {
    trackNodeHistory(this, node, this.emitter)
  };
}

export default FrameComponent;
